import React from 'react';
import type { KryspaceSlugSource } from '../../utils/resolveKryspaceWorkspaceSlug';

export interface RenderSurfaceBindingSubtitleProps {
  companyLabel: string;
  effectiveSlug: string;
  slugFromRoute: boolean;
  slugSource?: KryspaceSlugSource;
  derivedSlug?: string;
  className?: string;
  style?: React.CSSProperties;
}

export function formatSlugSourceLabel(source: KryspaceSlugSource): string {
  switch (source) {
    case 'kryspace_slug':
      return 'kryspace_slug';
    case 'metadata':
      return 'metadata';
    case 'name_hint':
      return 'name hint';
    default:
      return source;
  }
}

export const RenderSurfaceBindingSubtitle: React.FC<RenderSurfaceBindingSubtitleProps> = ({
  companyLabel,
  effectiveSlug,
  slugFromRoute,
  slugSource,
  derivedSlug,
  className,
  style,
}) => {
  const sourceLabel = slugFromRoute
    ? 'URL override'
    : slugSource
      ? formatSlugSourceLabel(slugSource)
      : 'unknown';

  return (
    <p className={className} style={style} data-testid="render-surface-binding-subtitle">
      Company: <strong>{companyLabel}</strong> · Slug: <strong>{effectiveSlug}</strong> · Source:{' '}
      <strong>{sourceLabel}</strong>
      {!slugFromRoute && slugSource === 'name_hint' ? (
        <span> (set companies.kryspace_slug or metadata.engineering_workspace_slug)</span>
      ) : null}
      {slugFromRoute && derivedSlug && effectiveSlug !== derivedSlug ? (
        <span> (header company maps to {derivedSlug})</span>
      ) : null}
    </p>
  );
};
